import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

//custom Component
import Audiobufferloader from './audiobufferloader';
import Audioslider from './audioslider';

//custo styles
import '../styles/transition-group.scss';

class Audioelement extends React.Component{

	constructor(props){
		super(props);
		this.state = {
			ready : false,
			audioIsPlaying : false,
			readyCount : 0,
			innerContextTime : 0,
			startFromBeginning : true,
			sliderVisible : true,
			volumeHasChanged : false,
			spur : {
				Bass : {
					name : 'Bass',
					value : .75,
					source : null,
					playing : false,
				},
				Drums : {
					name : 'Drums',
					value : .7,
					source : null,
					playing : false,
				},
				Guitar : {
					name : 'Guitar',
					value : .9,
					source : null,
					playing : false,
				},
				Vocals : {
					name : 'Vocals',
					value : .8 ,
					source : null,
					playing : false,
				}
			}
		}

		this.toggleSliders = this.toggleSliders.bind(this);

		this.addHandler();
	}

	componentDidMount(){
		console.log('audio did mount');
	}

	componentWillUnmount(){
		this.pauseTracks();
	}


	addHandler(){
		window.addEventListener('touchmove',function(event){
			if(this.state.sliderVisible){

				if(event.target.type != "range"){
					event.preventDefault();
				}

				
			}
		}.bind(this));

	}
	//fire play from outside(main timeline)
	componentWillReceiveProps(nextProps){
		//if(nextProps.makeAudioActive){
			//console.log('play audio tracks')
			if(nextProps.isPlaying != this.state.audioIsPlaying){
				console.log('start audio');

					if(nextProps.isPlaying ){
						//console.log('playTracks');
						this.playTracks();
					}else{
						//console.log('pauseTracks');
						this.pauseTracks();
					}
			
				this.setState({
					audioIsPlaying : nextProps.isPlaying
				});	
			}
		//}
	}

	prepareSource(name,buffer,loop) {
		var audioSource = _assets.audioContext.createBufferSource();
				audioSource.buffer = buffer;
		var gainNode = _assets.audioContext.createGain ? _assets.audioContext.createGain() : _assets.audioContext.createGainNode();
			  audioSource.connect(gainNode);
			  gainNode.connect(_assets.audioContext.destination);

			  audioSource.start(0, this.props.timecode  );
			  // if(this.state.startFromBeginning === true){
			  // 	audioSource.start(0);
			  	
			  // }else{
			  // }

			  gainNode.gain.value = this.state.spur[name].value;

		var audioState = Object.assign(this.state.spur[name], {
			  	gainNode : gainNode,
			  	source : audioSource
			  })
				this.setState(audioState);	  
		  //return soundSource;
	}

	playTracks(){

		for(let singleSpur in this.state.spur){
			this.prepareSource(singleSpur,_assets.loaded.spur[singleSpur].buffer,false);
		}
		this.setState({
			audioIsPlaying : true,
			startFromBeginning : false,
		});
	}

	pauseTracks(){
		for(let singleSpur in this.state.spur){
			this.state.spur[singleSpur].source.stop();
		}
	}

	resetVolume(){

		this.changeSpurVolume('Bass', .75);
		this.changeSpurVolume('Drums',  .7);
		this.changeSpurVolume('Guitar', .9);
		this.changeSpurVolume('Vocals',  .8);
		this.setState({
			volumeHasChanged : false
		});

	}

	changeSpurVolume(name,value){
		let slideVol = Object.assign( this.state.spur[name], {
			value: value 
		});
			
		this.setState(slideVol);
		this.state.spur[name].gainNode.gain.value = this.state.spur[name].value;

	}



	changeVol(event){
		event.preventDefault(event);
		event.stopPropagation();
		if(this.props.isPlaying){
			this.changeSpurVolume(event.target.name,event.target.value);
			
			this.setState({
				volumeHasChanged : true
			});
		}
	}

	toggleSliders(){
		this.setState({
			sliderVisible : !this.state.sliderVisible
		});

	}


	render(){
		return (
			<div className="audio-element">
				<div className="audio-element-inner">
					<div className="audio-element-range-slider">
					{this.state.sliderVisible && 
						<button className={"resetAudioVolume hasChanged-" + this.state.volumeHasChanged} onClick={this.resetVolume.bind(this)}>Reset Volume</button>
					}
					<button className="audio-element-toggle-sliders" onClick={this.toggleSliders}>
						{this.state.sliderVisible && 
						<span>Hide mixer</span>
						}
						{!this.state.sliderVisible && 
						<span>Show mixer</span>
						}
					</button>
			      <ReactCSSTransitionGroup
								component= "div"
								className="audio-slider-holder"
			          transitionName="fade"
			          transitionAppear={true}
     						transitionAppearTimeout={500}
			          transitionEnterTimeout={500}
			          transitionLeaveTimeout={300}>
			          {this.state.sliderVisible &&
			      			<div className="audio-slider-inner" key="audioslider">
										<Audioslider value={this.state.spur['Guitar'].value} name={'Guitar'} onChange={this.changeVol.bind(this)}/>
										<Audioslider value={this.state.spur['Vocals'].value} name={'Vocals'} onChange={this.changeVol.bind(this)}/>
										<Audioslider value={this.state.spur['Drums'].value} name={'Drums'} onChange={this.changeVol.bind(this)}/>
										<Audioslider value={this.state.spur['Bass'].value} name={'Bass'} onChange={this.changeVol.bind(this)}/>
									</div>
								}
						</ReactCSSTransitionGroup>
					</div>
				</div>
			</div>
			);
	}

}


export default Audioelement;


// WEBPACK FOOTER //
// ./src/scripts/audioelement.js